import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { FiEdit2 } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import { ToastContainer } from "react-toastify";
import ContentLoader from "react-content-loader";
import changeMonthToText from "../../utils/ChangeMonthToText";
import DownloadBtn from "../../components/DownloadBtn";
import { currentDate } from "../../utils/currentDate";

import {
  createAcYear,
  deleteAcYear,
  getAcYears,
  updateAcYear,
} from "../../store/actions/AcYearsActions";
import { getBeneficiries } from "../../store/actions/BenActions";
import {
  createAcTerm,
  deleteAcTerm,
  getAcTerms,
  updateAcTerm,
} from "../../store/actions/AcTermActions";
import {
  addBenMark,
  deleteBenMark,
  getBenMarks,
  updateBenMark,
} from "../../store/actions/PerformanceActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";

function Academics() {
  const dispatch = useDispatch();
  // for Academics table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "AcYear",
        accessor: "termAndClass",
      },
      {
        Header: "Level",
        accessor: "level",
      },
      {
        Header: "Class",
        accessor: "class",
      },
      {
        Header: "Marks(%)",
        accessor: "marks",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // tabs controller
  const [openTab, setOpenTab] = useState(1);
  // fetching academic terms and years
  const loaders = useSelector((state) => state.loadersState);
  const years = useSelector((state) => state.acYears);
  const acTerms = useSelector((state) => state.acTerms);
  const benMarks = useSelector((state) => state.benMarks);
  const beneficiaries = useSelector((state) => state.beneficiries);

  // academic years
  const [acYear, setAcYear] = useState({
    id: "",
    name: "",
  });
  // academic years
  const [mark, setMark] = useState({
    id: "",
    beneficiaryClass: "",
    beneficiaryId: "",
    combination: "",
    marks: "",
    status: "",
    termId: "",
    yearId: "",
  });
  // academic years
  const [acTerm, setAcTerm] = useState({
    id: "",
    termName: "",
    startDate: "",
    endDate: "",
  });
  const terms = acTerms;
  // overlays
  //  adding marks overlay controllers
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    dispatch({
      type: "REGISTER_PERFORMANCE_FAILED",
      registerMarksActionFailedMessage: "",
    });
    setMark({
      id: "",
      beneficiaryClass: "",
      beneficiaryId: "",
      combination: "",
      marks: "",
      level: "",
      status: "",
      termId: 0,
      yearId: 0,
    });
    setAddBeneOverlay(!addBenOverlay);
  }
  // filtering beneficiries overlay controllers
  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  // edit beneficiary info overlay controllers
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedMark) {
    dispatch({
      type: "REGISTER_PERFORMANCE_FAILED",
      registerMarksActionFailedMessage: "",
    });
    setEditBeneOverlay(!editBenOverlay);
    setMark({
      id: passedMark.id,
      beneficiaryClass: passedMark.beneficiaryClass,
      beneficiaryId: passedMark.beneficiaryId,
      combination: passedMark.combination,
      level: passedMark.level,
      marks: passedMark.marks,
      status: passedMark.status,
      termId: passedMark.termId,
      yearId: passedMark.yearId,
    });
  }
  // add years overlay controllers
  const [addYear, setAddYear] = useState(0);
  function addYearController() {
    setAddYear(!addYear);
  }
  // adding terms overlay contollers
  const [addTerm, setAddTerm] = useState(0);
  function addTermController() {
    setAddTerm(!addTerm);
  }
  // editing overlay controllers
  const [editTerm, setEditTerm] = useState(0);
  function editTermController(passedAcTerm) {
    setEditTerm(!editTerm);
    setAcTerm({
      id: passedAcTerm.id,
      termName: passedAcTerm.termName,
      startDate: changeFromTimeStamp(passedAcTerm.startDate),
      endDate: changeFromTimeStamp(passedAcTerm.endDate),
    });
  }
  // edit academic year overlay controller
  const [editYear, setEditYear] = useState(0);
  function editYearController(passedAcYear) {
    setEditYear(!editYear);
    setAcYear({
      id: passedAcYear.yearInfo.id,
      name: passedAcYear.yearInfo.name,
    });
  }
  // reload years
  useEffect(() => {
    dispatch(getAcYears());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // reload academic terms
  useEffect(() => {
    dispatch(getAcTerms());
    console.log(benMarks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // reload beneficiary marks
  useEffect(() => {
    dispatch(getBenMarks());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
  }, [dispatch]);

  // handle year submit
  const handleYearSubmit = (e) => {
    e.preventDefault();
    if (acYear.id) {
      const id = acYear.id;
      const updatedYear = {
        name: acYear.name,
      };
      dispatch(updateAcYear(updatedYear, id, closeAcYearFormAfterUpdating));
    } else {
      dispatch(createAcYear(acYear, closeAcYearFormAfterAdding));
    }
  };

  // handle year submit
  const handleMarksSubmit = (e) => {
    e.preventDefault();
    if (mark.id) {
      const id = mark.id;
      const updatedMark = {
        beneficiaryClass: mark.beneficiaryClass,
        beneficiaryId: mark.beneficiaryId,
        combination: mark.combination,
        level: mark.level,
        marks: mark.marks,
        status: mark.marks > 50 ? "YARATSINZE" : "YARATSINZWE",
        termId: mark.termId,
        yearId: mark.yearId,
      };
      dispatch(updateBenMark(updatedMark, id, closeMarkFormAfterUpdating));
    } else {
      const newMark = {
        ...mark,
        status: mark.marks > 50 ? "WIN" : "LOST",
      };
      dispatch(addBenMark(newMark, closeMarkFormAfterAdding));
    }
  };

  // handle year submit
  const handleTermSubmit = (e) => {
    e.preventDefault();
    if (acTerm.id) {
      const id = acTerm.id;
      const updatedTerm = {
        yearId: academicYears[yearDropdown].yearInfo.id,
        termName: acTerm.termName,
        startDate: acTerm.startDate,
        endDate: acTerm.endDate,
      };
      dispatch(updateAcTerm(updatedTerm, id, closeAcTermFormAfterUpdating));
    } else {
      const newTerm = {
        ...acTerm,
        yearId: academicYears[yearDropdown].yearInfo.id,
      };

      dispatch(createAcTerm(newTerm, closeAcTermFormAfterAdding));
    }
  };
  // handle delete ac year
  const handleAcYearDelete = (id) => {
    dispatch(deleteAcYear(id));
  };
  // handle delete term year
  const handleTermDelete = (id) => {
    dispatch(deleteAcTerm(id));
  };
  // year dropdowns
  const [yearDropdown, setYearDropDown] = useState(0);
  // academics year

  const academicYears = [];
  for (let i = 0; i < years.length; i++) {
    const year = {
      yearInfo: {
        id: years[i].id,
        name: years[i].name,
      },
      terms: acTerms.filter((term) => term.years.id === years[i].id),
    };
    academicYears.push(year);
  }
  // transform marks data
  let [loadedMarks, setLoadedMarks] = useState([]);

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteBenMark(id));
  };
  const selectedTerms = acTerms.filter((term) => term.years.id === mark.yearId);
  // terms select option
  const termsOption = [];
  for (let i = 0; i < selectedTerms.length; i++) {
    const term = {
      value: acTerms[i].id,
      label: acTerms[i].termName,
    };

    termsOption.push(term);
  }
  // years select option
  const yearsOption = [];
  for (let i = 0; i < years.length; i++) {
    const year = {
      value: years[i].id,
      label: years[i].name,
    };

    yearsOption.push(year);
  }
  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }
  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === mark.beneficiaryId
  );
  // closing form after mark cu
  function closeMarkFormAfterAdding() {
    benOverlayController();
    setMark({
      id: "",
      beneficiaryClass: "",
      beneficiaryId: "",
      combination: "",
      marks: "",
      level: "",
      status: "",
      termId: 0,
      yearId: 0,
    });
  }

  function closeMarkFormAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryClass: "",
      beneficiaryId: "",
      combination: "",
      marks: "",
      status: "",
      level: "",
      termId: 0,
      yearId: 0,
    });
  }
  // closing acYear after cu
  function closeAcYearFormAfterAdding() {
    addYearController();
    setAcYear({
      id: "",
      name: "",
    });
  }

  function closeAcYearFormAfterUpdating() {
    editYearController({
      yearInfo: {
        id: "",
        name: "",
      },
    });
  }

  // closing ac term after cu
  function closeAcTermFormAfterAdding() {
    addYearController();
    setAcTerm({
      id: "",
      termName: "",
      startDate: "",
      endDate: "",
    });
  }

  function closeAcTermFormAfterUpdating() {
    editTermController({
      id: "",
      termName: "",
      startDate: "",
      endDate: "",
    });
  }

  let [loadingMarks, setLoadingMarks] = useState([]);

  useEffect(() => {
    setLoadedMarks([]);
    for (let i = 0; i < benMarks.length; i++) {
      const benMark = {
        count: i + 1,
        id: benMarks[i].id,
        beneficiary: ` ${benMarks[i].beneficiary.firstName}  
      ${benMarks[i].beneficiary.lastName}`,
        beneficiaryId: benMarks[i].beneficiary.id,
        beneficiaryClass: benMarks[i].beneficiaryClass,
        combination: benMarks[i].combination,
        level: benMarks[i].level,
        termAndClass:
          benMarks[i].years.name + "(Term" + benMarks[i].terms.termName + ")",
        marks: benMarks[i].marks,
        class:
          benMarks[i].beneficiaryClass + "(" + benMarks[i].combination + ")",
        termId: benMarks[i].terms.id,
        yearId: benMarks[i].years.id,
        status: (
          <div className={"py-1 px-2 rounded   font-normal  fit-content"}>
            {capitalizeFirstLetter(benMarks[i].status)}
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editOverlayController(benMark);
            }}
            deleteAction={() => {
              handleDelete(benMarks[i].id);
            }}
          />
        ),
      };
      setLoadedMarks((loadedMarks) => [...loadedMarks, benMark]);

      if (loaders.deletingMarks.deleting) {
        const currentMarks = loadedMarks;
        const newData = currentMarks.map((mark) =>
          mark.id === loaders.deletingMarks.id
            ? {
              ...mark,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : mark
        );
        setLoadedMarks(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benMarks, loaders.deletingMarks.deleting]);

  useEffect(() => {
    setLoadingMarks([]);
    for (let i = 0; i < 5; i++) {
      const benMark = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiaryClass: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        combination: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        level: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        termAndClass: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        marks: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        class: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingMarks((loadingMarks) => [...loadingMarks, benMark]);
    }
  }, [loaders.fetchingMarksLoaders]);
  function clearErrors() {
    dispatch({
      type: "SET_AC_YEAR_MESSAGE",
      AcYearMessage: "",
    });
    dispatch({
      type: "REGISTER_PERFORMANCE_FAILED",
      registerMarksActionFailedMessage: "",
    });
  }

  const levelOptions = [
    {
      value: "REB",
      label: "REB",
    },
    {
      value: "RTB",
      label: "RTB",
    },
    {
      value: "VTC",
      label: "VTC",
    },
  ];
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="bg-white mx-10">
        <div className="flex flex-col md:flex-row p-10 pt-5 pl-10 pb-0">
          <h2 className="font-semibold">Academic performance</h2>
          <div className="mt-2 md:m-auto md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              onClick={() => {
                benOverlayController();
              }}
              message="Register"
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              onClick={() => {
                filterOverlayController();
              }}
              message="Filter"
            >
              <FiFilter />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              message="Refresh"
              onClick={() => {
                dispatch(getBenMarks());
              }}
            >
              <FcRefresh
                className={
                  loaders.fetchingMarksLoaders ? " refresh-loader" : " "
                }
              />
            </button>
            <DownloadBtn filename={`academics-${changeMonthToText(currentDate())}`} table="table-to-xls" />
          </div>
        </div>
        <div className="md:pb-5 ml-10 mr-10 border-gray-300" />
        <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
          {/* Academics table */}
          <div className="w-full">
            {(!loaders.fetchingMarksLoaders && loadedMarks.length < 1) |
              loaders.fetchingMarksErroredMessage ? (
              <div
                className={
                  !loaders.fetchingMarksErroredMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.fetchingMarksErroredMessage
                    ? "No marks found"
                    : loaders.fetchingMarksErroredMessage}
                </p>
              </div>
            ) : (
              <Table
                data={loaders.fetchingMarksLoaders ? loadingMarks : loadedMarks}
                columns={columns}
              />
            )}
          </div>
        </div>
        {/*add marks overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.registerMarksActionFailedMessage && openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.registerMarksActionFailedMessage}</p>
              </div>
              <div
                className={
                  (loaders.AcYearMessage && openTab === 2) ||
                    (loaders.term.message && openTab === 2)
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>
                  {loaders.AcYearMessage
                    ? loaders.AcYearMessage
                    : loaders.term.message}
                </p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay ? "Register " : "Change info on"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                            beneficiaryClass: "",
                            beneficiaryId: "",
                            combination: "",
                            marks: "",
                            status: "",
                            level: "",
                            termId: "",
                            yearId: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex font-medium mb-0 list-none flex-wrap    flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Marks
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i> Academic
                          years
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleMarksSubmit}
                            >
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Beneficiary Id</label>
                                <Select
                                  options={beneficiriesOption}
                                  value={beneficiriesOption.find(
                                    (obj) => obj.value === mark.beneficiaryId
                                  )}
                                  onChange={(e) =>
                                    setMark({
                                      ...mark,
                                      beneficiaryId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Name </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={
                                      mark.beneficiaryId
                                        ? selectedBeneficiary[0].name
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <label>Academic year </label>
                                <Select
                                  options={yearsOption}
                                  value={yearsOption.find(
                                    (obj) => obj.value === mark.yearId
                                  )}
                                  onChange={(e) =>
                                    setMark({
                                      ...mark,
                                      yearId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <label>Academic term </label>
                                <Select
                                  options={termsOption}
                                  value={termsOption.find(
                                    (obj) => obj.value === mark.termId
                                  )}
                                  onChange={(e) =>
                                    setMark({
                                      ...mark,
                                      termId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <label>Academic Level </label>
                                <Select
                                  options={levelOptions}
                                  value={levelOptions.find(
                                    (obj) => obj.value === mark.level
                                  )}
                                  onChange={(e) =>
                                    setMark({
                                      ...mark,
                                      level: e.value,
                                    })
                                  }
                                />
                              </div>
                              <div className="flex">
                                {/*  field */}
                                <div className="py-2  w-full mr-2">
                                  <label>Current Class </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={mark.beneficiaryClass}
                                      onChange={(e) =>
                                        setMark({
                                          ...mark,
                                          beneficiaryClass: e.target.value,
                                        })
                                      }
                                    />
                                  </div>{" "}
                                </div>
                                {/*  field */}
                                <div className="py-2  w-full">
                                  <label>Section </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={mark.combination}
                                      onChange={(e) =>
                                        setMark({
                                          ...mark,
                                          combination: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Marks(%) </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="number"
                                    className={style.field.input}
                                    value={mark.marks}
                                    onChange={(e) =>
                                      setMark({
                                        ...mark,
                                        marks: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              {/* save btn */}
                              <button
                                type="submit"
                                className={style.loginBtn}
                                disabled={loaders.sendingMarksLoader}
                              >
                                {!loaders.sendingMarksLoader ? (
                                  <p className="m-auto">
                                    {addBenOverlay ? "Save" : "Update"}
                                  </p>
                                ) : (
                                  <div className="spinner m-auto">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                )}
                              </button>
                            </form>
                          </div>
                          <div
                            className={openTab === 2 ? "block" : "hidden"}
                            id="link2"
                          >
                            {/* academic years  */}
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addYear & !addTerm & !editTerm & !editYear
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addYearController();
                                }}
                              >
                                {"New academic year"}
                              </button>

                              <div
                                className={
                                  !addYear & !addTerm & !editYear & !editTerm
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.term.fetchingLoaders ||
                                  loaders.fetchingAcYearLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  academicYears.map((acYear, i) => {
                                    return loaders.deletingAcYear.id ===
                                      acYear.yearInfo.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          yearDropdown === i
                                            ? "border border-gray-100 p-3 mb-3 rounded bg-gray-50"
                                            : "border border-gray-100 p-3 mb-3 rounded bg-gray-50"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setYearDropDown(i);
                                        }}
                                      >
                                        <div className="flex mb-2 m-auto text-center cursor-pointer">
                                          <h2 className="font-semibold m-auto">
                                            {"Ac year " + acYear.yearInfo.name}
                                          </h2>
                                        </div>
                                        <div
                                          className={
                                            yearDropdown === i
                                              ? "flex flex-col"
                                              : "hidden"
                                          }
                                        >
                                          {acYear.terms.map((term, i) => {
                                            return loaders.term
                                              .deletingAction &&
                                              loaders.term.deletingAction.id ===
                                              term.id ? (
                                              <div className="spinner m-auto red-spinner">
                                                <div className="bounce1"></div>
                                                <div className="bounce2"></div>
                                                <div className="bounce3"></div>
                                              </div>
                                            ) : (
                                              <div
                                                className="rounded p-3 mb-1 flex term border border-indigo-200 bg-white"
                                                key={i}
                                              >
                                                <div className="flex flex-col m-auto ml-0">
                                                  <h2 className="font-semibold">
                                                    Term {term.termName}
                                                  </h2>
                                                  <p className="text-gray-500">
                                                    {changeMonthToText(
                                                      new Intl.DateTimeFormat(
                                                        "en-US"
                                                      ).format(term.startDate)
                                                    )}
                                                    --
                                                    {changeMonthToText(
                                                      new Intl.DateTimeFormat(
                                                        "en-US"
                                                      ).format(term.endDate)
                                                    )}
                                                  </p>
                                                </div>
                                                <div className="m-auto mr-0 hidden fit-content action">
                                                  <button
                                                    className="flex p-1 rounded border border-gray-300 hover:border-gray-300 bg-gray-300 hover:bg-transparent text-gray-500 mr-2"
                                                    onClick={() => {
                                                      editTermController(term);
                                                    }}
                                                  >
                                                    <FiEdit2 />
                                                  </button>
                                                  <button
                                                    className="flex p-1 rounded border border-red-300 hover:border-red-300 bg-red-300 hover:bg-transparent text-red-500 mr-2"
                                                    onClick={() => {
                                                      handleTermDelete(term.id);
                                                    }}
                                                  >
                                                    <AiOutlineDelete />
                                                  </button>
                                                </div>
                                              </div>
                                            );
                                          })}
                                          <div className="flex m-auto fit-content pt-2">
                                            <button
                                              className="flex p-1 rounded border border-gray-100 hover:border-gray-300 bg-gray-100 hover:bg-gray-300 text-gray-500 mr-2"
                                              onClick={() => {
                                                editYearController(acYear);
                                              }}
                                            >
                                              Edit
                                            </button>
                                            <button
                                              className="flex p-1 rounded border border-red-100 hover:border-red-300 bg-red-100 hover:bg-red-300 text-red-500 mr-2"
                                              onClick={() => {
                                                handleAcYearDelete(
                                                  acYear.yearInfo.id
                                                );
                                              }}
                                            >
                                              Delete
                                            </button>
                                            <button
                                              className="flex p-1 rounded border border-indigo-100 hover:border-indigo-300 bg-indigo-100 hover:bg-indigo-300 text-indigo-500"
                                              onClick={() => {
                                                addTermController();
                                              }}
                                            >
                                              New term
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add year */}
                              <form
                                onSubmit={handleYearSubmit}
                                className={
                                  addYear & !addTerm || editYear & !addTerm
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                              >
                                <h2 className="font-semibold">
                                  {addYear
                                    ? "Register Academic year"
                                    : "Change Academic year info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Academic name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={acYear.name}
                                      onChange={(e) =>
                                        setAcYear({
                                          ...acYear,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <button
                                    type="submit"
                                    className={style.loginBtn}
                                    disabled={loaders.sendingAcYearLoader}
                                  >
                                    {!loaders.sendingAcYearLoader ? (
                                      <p className="m-auto">
                                        {addYear ? "Save" : "Update"}
                                      </p>
                                    ) : (
                                      <div className="spinner m-auto">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    )}
                                  </button>
                                </div>
                                <p
                                  className={
                                    addYear | editYear
                                      ? "p-3 pl-0 flex rounded text-indigo-500 font-normal mb-3 cursor-pointer"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addYear
                                      ? addYearController()
                                      : editYearController({
                                        yearInfo: {
                                          id: "",
                                          name: "",
                                        },
                                      });
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </form>
                              {/* add term */}
                              <form
                                onSubmit={handleTermSubmit}
                                className={
                                  addTerm & !addYear || editTerm & !addYear
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                              >
                                <h2 className="font-semibold">
                                  {addTerm
                                    ? "Register term in 2020-2021"
                                    : "Change academic term info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Term name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="number"
                                      className={style.field.input}
                                      value={acTerm.termName}
                                      onChange={(e) =>
                                        setAcTerm({
                                          ...acTerm,
                                          termName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  {/*  field */}

                                  <div className="py-2 w-full">
                                    <label>Start date </label>
                                    <div className={style.field.parentDiv}>
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={acTerm.startDate}
                                        onChange={(e) =>
                                          setAcTerm({
                                            ...acTerm,
                                            startDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/*  field */}
                                  <div className="py-2 w-full">
                                    <label>End date </label>
                                    <div className={style.field.parentDiv}>
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={acTerm.endDate}
                                        onChange={(e) =>
                                          setAcTerm({
                                            ...acTerm,
                                            endDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      className={style.loginBtn}
                                      disabled={loaders.term.sendingLoader}
                                    >
                                      {!loaders.term.sendingLoader ? (
                                        <p className="m-auto">
                                          {addTerm ? "Save" : "Update"}
                                        </p>
                                      ) : (
                                        <div className="spinner m-auto">
                                          <div className="bounce1"></div>
                                          <div className="bounce2"></div>
                                          <div className="bounce3"></div>
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                </div>
                                <p
                                  className={
                                    addTerm | editTerm
                                      ? "p-3 pl-0 flex rounded text-indigo-500 font-normal  m-auto cursor-pointer"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addTerm
                                      ? addTermController()
                                      : editTermController({
                                        id: "",
                                        termName: "",
                                        startDate: "",
                                        endDate: "",
                                      });
                                  }}
                                >
                                  <BsArrowLeft className="m-auto mx-0 mr-2 " />{" "}
                                  {"Back"}
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter Academics score overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold">
                  {"Filter academic performance"}
                </h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col pt-3">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range</label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>{" "}
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Academic years </label>
                  <Select options={years} isMulti />
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Academic terms </label>
                  <Select options={terms} isMulti />
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Marks range(%) </label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="50"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="number"
                        className={style.field.input}
                        placeholder="70"
                      />
                    </div>
                  </div>
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">{"Apply"}</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Academic year</th>
            <th>Level</th>
            <th>Class</th>
            <th>Marks(%)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {benMarks.map((benMark) =>
            <tr>
              <td>{benMark.beneficiary.firstName} {benMark.beneficiary.lastName}</td>
              <td>{benMark.years.name}({terms.termName})</td>
              <td>{benMark.level}</td>
              <td>{benMark.beneficiaryClass}</td>
              <td>{benMark.marks}</td>
              <td>{benMark.status}</td>
            </tr>
          )}
        </tbody>
      </table>
    </DashLayout>


  );
}

export default Academics;
